interface RegistrationErrors {
  isError: boolean;
  errorCode: number | null;
  errorMessage: string;
}

interface PeriodType {
  periodTypeId: string;
  periodItems: number[];
}

interface CalculatorSettings {
  sumItems: number[];
  periodTypeItems: PeriodType[];
}

type DefaultCalculatorSettings = CalculatorSettings | Record<string, never>;

interface RegistrationState {
  isLoading: boolean;
  refSources: string;
  firstName: string;
  lastName: string;
  middleName: string;
  birthDate: string;
  email: string;
  phone: string;
  tempUserId: string;
  codeId: string;
  genderId: string;
  errors: RegistrationErrors;
  defaultCalculatorSettings: DefaultCalculatorSettings;
}

const SET_IS_LOADING = "SET_IS_LOADING";
const SET_USER_DATA = "SET_USER_DATA";
const SET_CODES = "SET_CODES";
const SET_REGISTRATION_ERRORS = "SET_REGISTRATION_ERRORS";
const SET_DEFAULT_CALCULATOR_SETTINGS = "SET_DEFAULT_CALCULATOR_SETTINGS";
const RESET = "RESET";

interface SetIsLoadingAction {
  type: typeof SET_IS_LOADING;
  payload: boolean;
}

interface SetUserDataAction {
  type: typeof SET_USER_DATA;
  payload: Partial<RegistrationState>;
}

interface CodeIdsPayload {
  tempUserId?: string;
  codeId: string;
  genderId?: string;
}

interface SetCodesAction {
  type: typeof SET_CODES;
  payload: CodeIdsPayload;
}

interface SetRegistrationErrorsAction {
  type: typeof SET_REGISTRATION_ERRORS;
  payload: RegistrationErrors;
}

interface SetDefaultCalculatorSettingsAction {
  type: typeof SET_DEFAULT_CALCULATOR_SETTINGS;
  payload: CalculatorSettings;
}

interface ResetAction {
  type: typeof RESET;
}

type RegistrationAction =
  | SetIsLoadingAction
  | SetUserDataAction
  | SetCodesAction
  | SetRegistrationErrorsAction
  | SetDefaultCalculatorSettingsAction
  | ResetAction
  | null;

const initialState: RegistrationState = {
  isLoading: false,
  refSources: "",
  firstName: "",
  lastName: "",
  middleName: "",
  birthDate: "",
  email: "",
  phone: "",
  tempUserId: "",
  codeId: "",
  genderId: "",
  errors: {
    isError: false,
    errorCode: null,
    errorMessage: "",
  },
  defaultCalculatorSettings: {},
};

export const registrationReducer = (
  state: RegistrationState = initialState,
  action: RegistrationAction = null
) => {
  switch (action?.type) {
    case SET_IS_LOADING:
      return { ...state, isLoading: action.payload };
    case SET_USER_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case SET_CODES:
      return {
        ...state,
        ...action.payload,
      };
    case SET_REGISTRATION_ERRORS:
      return { ...state, errors: action.payload };
    case SET_DEFAULT_CALCULATOR_SETTINGS:
      return { ...state, defaultCalculatorSettings: action.payload };
    case RESET:
      return initialState;
    default:
      return state;
  }
};
